import script from "./ModalCambiarEstadoListaEquipos.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCambiarEstadoListaEquipos.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCambiarEstadoListaEquipos.vue?vue&type=style&index=0&id=654385b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-654385b8"]])

export default __exports__